import { render, staticRenderFns } from "./legr_list.vue?vue&type=template&id=576c6917&scoped=true"
import script from "./legr_list.vue?vue&type=script&lang=js"
export * from "./legr_list.vue?vue&type=script&lang=js"
import style0 from "./legr_list.vue?vue&type=style&index=0&id=576c6917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c6917",
  null
  
)

export default component.exports